import { useParams } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";
import useBlobStorageFlag from "hooks/useBlobStorageFlag";
import useOriginFlag from "hooks/useOriginFlag";

import VCSIntegrationsManageGitHubEnterprise from "./ManageGitHubEnterprise";
import VCSIntegrationsManageOrigin from "./ManageOrigin";
import { VCS_PROVIDERS_URL_KEYS } from "../constants";
import VCSIntegrationsManageGitLab from "./ManageGitLab";
import VCSIntegrationsManageAzureDevOps from "./ManageAzureDevOps";
import VCSIntegrationsManageBitbucketCloud from "./ManageBitbucketCloud";
import VCSIntegrationsManageBitbucketDataCenter from "./ManageBitbucketDataCenter";
import VCSIntegrationsManageBlobStorage from "./ManageBlobStorage";

const VCSIntegrationsManageRoutes = () => {
  const { provider } = useParams<{ provider: string }>();
  const blobStorageEnabled = useBlobStorageFlag();
  const originEnabled = useOriginFlag();

  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (provider) {
    case VCS_PROVIDERS_URL_KEYS.AZURE_DEVOPS:
      return <VCSIntegrationsManageAzureDevOps />;
    case VCS_PROVIDERS_URL_KEYS.BITBUCKET_CLOUD:
      return <VCSIntegrationsManageBitbucketCloud />;
    case VCS_PROVIDERS_URL_KEYS.BITBUCKET_DATACENTER:
      return <VCSIntegrationsManageBitbucketDataCenter />;
    case VCS_PROVIDERS_URL_KEYS.GITHUB_ENTERPRISE:
    case VCS_PROVIDERS_URL_KEYS.GITHUB:
      return <VCSIntegrationsManageGitHubEnterprise />;
    case VCS_PROVIDERS_URL_KEYS.ORIGIN:
      return originEnabled ? <VCSIntegrationsManageOrigin /> : <NotFoundPage />;
    case VCS_PROVIDERS_URL_KEYS.GITLAB:
      return <VCSIntegrationsManageGitLab />;
    case VCS_PROVIDERS_URL_KEYS.BLOB:
      return blobStorageEnabled ? <VCSIntegrationsManageBlobStorage /> : <NotFoundPage />;
    default:
      return <NotFoundPage />;
  }
};

export default VCSIntegrationsManageRoutes;
